module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/mppAccounts/Account.ejs -->\n<td>'+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('username') ))==null?'':_.escape(__t))+
'</td>\n<td>\n    <input class="hide js-change-mpp-logo-input"\n        type="file" accept="image/*"\n        value="'+
((__t=( model.getLogoUrl() || '' ))==null?'':_.escape(__t))+
'" >\n    <p class="form-control-static hidden">\n        <img class="company-logo"\n            src="'+
((__t=( model.getLogoUrl() || '' ))==null?'':_.escape(__t))+
'" />\n    </p>\n    <div class="change-image-wrapper">\n        <span class="js-change-mpp-logo btn btn-default">\n            Add Logo\n        </span>\n        <span class="js-remove-mpp-logo btn btn-default hidden">\n            Remove Logo\n        </span>\n    </div>\n    <span class="error error-logo"></span>\n</td>\n<td>\n    <select name="mppPlan" class="form-control">\n        ';
 mppPlans.forEach(function(plan) { 
__p+='\n            <option value="'+
((__t=( plan.id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( subscription.get('plan') === plan.id ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( plan.name ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n<td>\n    ';

    var matchingCoupon = discountCodes.find(function (code) { return code.id === subscription.get('couponCode'); });
    
__p+='\n    <input name="discount"\n        list="couponCode"\n        value="'+
((__t=( matchingCoupon ? matchingCoupon.invoice_name || matchingCoupon.name : '' ))==null?'':_.escape(__t))+
'"\n    >\n    <datalist id="couponCode">\n    ';
 discountCodes.forEach(function (discountCode) { 
__p+='\n        <option value="'+
((__t=( discountCode.invoice_name || discountCode.name ))==null?'':_.escape(__t))+
'">\n    ';
 }) 
__p+='\n    </datalist>\n</td>\n<td>\n    <button\n        title="Force the creation of an invoice for all currently unpaid\n            payrolls"\n        class="js-invoice btn btn-default float-right">\n        <i class="fa fa-file-text-o"></i>\n        Invoice\n    </button>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/mppAccounts/Account.ejs
// module id = 680
// module chunks = 1